import React from 'react';
import { DISCLAIMER } from '../../data/catio';
export function DisclaimerSection() {
  return <section aria-labelledby="info-title" className="bg-ivory pb-12 sm:pb-16" data-id="element-158" data-mp="xqrrn025kfg3">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-159" data-mp="12i1fpw81zapv">
        <div className="border-t border-line pt-7" data-id="element-160" data-mp="12ite1et1bmju">
          <h2 id="info-title" className="label-tech text-graphite" data-id="element-161" data-mp="17hmf27r4xl34">
            Important information
          </h2>
          <ul className="mt-3 grid max-w-3xl gap-2" data-id="element-162" data-mp="9v72nkdkfdmf">
            {DISCLAIMER.map(line => <li key={line} className="text-[0.86rem] leading-relaxed text-graphite/85" data-id="element-163" data-mp="espa16bxpksb">
                {line}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}